// import React, { useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { useNavigate } from "react-router-dom";
// import { useSnapshot } from "valtio";
// import state from "../Components/Core/config/store";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { Canvas } from "@react-three/fiber";
// import {
//   OrbitControls,
//   Environment,
//   ContactShadows,
//   useGLTF,
// } from "@react-three/drei";

// function Banner() {
//   const navigate = useNavigate();
//   const snap = useSnapshot(state);
//   const { tokenDetails } = useSelector((state) => state.user);

//   const settings = {
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 2000,
//     arrows: true,
//     adaptiveHeight: true,
//   };

//   const [slides] = useState([
//     {
//       id: 1,
//       src: "/Images/BannerSports2.webp",
//       alt: "Sports Banner 1",
//     },
//     {
//       id: 2,
//       src: "/Images/BannerSports1.webp",
//       alt: "Sports Banner 2",
//     },
//   ]);

//   const handle3d = () => {
//     if (!tokenDetails) {
//       toast.error("Please login or Signup");
//       return;
//     }
//     navigate("/3d-product");
//   };

//   return (
//     <div style={{ position: "relative", width: "100%" }}>
//       <div className="cms-section background-gradient-1 brands-emotion pos-0 cms-section-default" style={{marginTop:"80px"}}>
//         <div className="cms-section-default full-width">
//           <div className="cms-block shield-banner-full-size white-text pos-0 cms-block-shield-banner">
//             <div className="cms-block-container">
//               <div className="cms-block-container-row row cms-row">
//                 <div
//                   className="col-12"
//                   data-cms-element-id="018ba9504eec7933acd658e8875145b4"
//                 >
//                   <div className="shield--banner-info-box" style={{cursor:"pointer"}}>
//                     <Slider {...settings}>
//                       {slides.map((slide) => (
//                         <div key={slide.id} className="image-slide">
//                           <img
//                             src={slide.src}
//                             className="img-fluid image-slider-image f_lazy desctop-image-view desctop-mobile-type"
//                             style={{ width: "100%" }}
//                             alt={slide.alt}
//                              onClick={() => {

//                                handle3d();
//                              }}
//                           />
//                         </div>
//                       ))}
//                     </Slider>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Banner;

import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { useSnapshot } from "valtio";
import state from "../Components/Core/config/store";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {motion} from 'framer-motion'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function Banner() {
  const navigate = useNavigate();
  const snap = useSnapshot(state);
  const [hover,setHover]=useState(false)
  const { tokenDetails } = useSelector((state) => state.user);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    adaptiveHeight: true,
    centerMode: false,
    variableWidth: false, 
     pauseOnHover: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: false
        }
      }
    ]
  };


   const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };

  const [slides] = useState([
    
   
    {
      id: 1,
      src: "/asset/img/design1.webp",
      alt: "Sports Banner 2",
    },
      {
      id: 2,
      src: "/asset/img/design2.webp",
      alt: "Sports Banner 2",
    },
    {
      id: 3,
      src: "/asset/img/3.webp",
      alt: "Sports Banner 2",
    },
     {
      id: 4,
      src: "/asset/img/4 (1).webp",
      alt: "Sports Banner 2",
    },
  ]);

  const [slies2]=useState([
    {
      id: 1,
      src: "/asset/img/Hero banner mobile 1.jpg",
      alt: "Sports Banner 2",
    },
     {
      id: 2,
      src: "/asset/img/Hero banner mobile 4.jpg",
      alt: "Sports Banner 2",
    },
    {
      id: 3,
      src: "/asset/img/Hero banner mobile 3.jpg",
      alt: "Sports Banner 2",
    },
    
  ])

  const handle3d = () => {
    if (!tokenDetails) {
      toast.error("Please login or Signup");
      return;
    }
    navigate("/3d-product");
  };

  return (
    <div style={{ 
      position: "relative", 
      width: "100%",
      overflow: "hidden" 
    }}>
      <div 
        className="cms-section background-gradient-1 brands-emotion pos-0 cms-section-default" 
        style={{
         
          width: "100%"
        }}
      >
        <div className="cms-section-default full-width" style={{ width: "100%" }}>
          <div 
            className="cms-block shield-banner-full-size white-text pos-0 cms-block-shield-banner" 
            style={{ width: "100%" }}
          >
            <div className="cms-block-container" style={{ width: "100%" }}>
              <div className="cms-block-container-row row cms-row" style={{ margin: 0, width: "100%" }}>
                <div
                  className="col-12"
                  data-cms-element-id="018ba9504eec7933acd658e8875145b4"
                  style={{ padding: 0 }}
                >
                 {window.innerWidth>756?
                  <div 
                    className="shield--banner-info-box" 
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      position:"relative",
                      display:"flex"
                    }}
                  >
                    <Slider {...settings}>
                      {slides.map((slide) => (
                        <div 
                          key={slide.id} 
                          className="image-slide"
                          style={{
                            width: "100%",
                            outline: "none" ,
                           position:"relative"
                          }}
                        >
                          <img
                            src={slide.src}
                            className="img-fluid image-slider-image f_lazy desctop-image-view desctop-mobile-type"
                            style={{ 
                              width: "100%",
                              height: "auto",
                              display: "block",
                              filter:"blur(0.3px)"
                            }}
                            alt={slide.alt}
                            
                          />
                          

                       
                        </div>
                      ))}
                    </Slider>
{/* 
                    <div 
                     className="marquee-container"
                    style={{position:"absolute",zIndex:100000,display:"flex",height:"3.5rem",alignItems:"center",
                    backgroundColor:"yellow",bottom:"20px",width:"100%",left:0}}>
                      {[1,2,3,4].map((i)=>(

                     
                       <div style={{ width: "120%",marginTop:"20px" }}>
                         
                          <div 
                             className="marquee-text"
                             style={{
                             animationDelay: `${ (30 / 30)}s`,
                             animationDuration: `${6}s`,
                       }}
                      >
                             <p style={{display:"flex",alignItems:"center",gap:"30px"}}>
                                <img src="\asset\img\star.png" style={{width:"25px"}}/>
                                <span style={{fontSize:"20px",fontWeight:300}}>The quality is assured</span>
                                </p>
                                 
                        </div>
                       </div> ))
                      }
                       </div> */}

                       
                  </div>
                  :
                  <div 
                    className="shield--banner-info-box" 
                    style={{
                      cursor: "pointer",
                      width: "100%",
                      position:"relative",
                      display:"flex",
                      marginTop:"5.6rem"
                    }}
                  >
                    <Slider {...settings}>
                      {slies2.map((slide) => (
                        <div 
                          key={slide.id} 
                          className="image-slide"
                          style={{
                            width: "100%",
                            outline: "none" ,
                           position:"relative"
                          }}
                        >
                          <img
                            src={slide.src}
                            className="img-fluid image-slider-image f_lazy desctop-image-view desctop-mobile-type"
                            style={{ 
                              width: "100%",
                              height: "auto",
                              display: "block",
                              filter:"blur(0.3px)"
                            }}
                            alt={slide.alt}
                            
                          />
                          

                       
                        </div>
                      ))}
                    </Slider>

                    <div 
                     className="marquee-container"
                    style={{position:"absolute",zIndex:1000,display:"flex",height:"3.5rem",alignItems:"center",
                    backgroundColor:"yellow",top:"100vh",width:"100%",left:0}}>
                      {[1,2,3,4].map((i)=>(

                     
                       <div style={{ width: "120%",marginTop:"20px" }}>
                         
                          <div 
                             className="marquee-text"
                             style={{
                             animationDelay: `${ (30 / 30)}s`,
                             animationDuration: `${6}s`,
                       }}
                      >
                             <p style={{display:"flex",alignItems:"center",gap:"30px"}}>
                                <img src="\asset\img\star.png" style={{width:"25px"}}/>
                                <span style={{fontSize:"20px",fontWeight:300}}>The quality is assured</span>
                                </p>
                                 
                        </div>
                       </div> ))
                      }
                       </div>

                       
                  </div>
                  
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

                     {/* Animated absolute text */}

                          <div
                          
                           
                            style={{
                              position: "absolute",
                              width:"50%",
                              bottom:window.innerWidth>656? "10rem":"4rem",
                              left: "3rem",
                              zIndex: 666,
                              color: "#fff",
                              fontWeight: 700,
                              textShadow: "0 2px 8px rgba(0,0,0,0.5)",
                              letterSpacing: "2px",
                              display:"flex",
                              flexDirection:"column",
                              gap:"5rem",
                              pointerEvents: "none",
                              alignItems:"start",
                              justifyContent:"center",
                              // Responsive font size
                            }}
                          >
                           {window.innerWidth>656? 
                           <motion.span 
                            whileInView={{ x: 0, y: 0, opacity: 1 }}
                            initial={{ x: 200, y: 80, opacity: 0 }}
                            transition={{ duration: 1, ease: "easeOut" }}
                            viewport={{ once: true, amount: 0.5 }}
                            style={{fontFamily:"revert-layer",fontSize:window.innerWidth<567?"4rem":"6.5rem"}}
                            className=" text-white text-2xl md:text-4xl font-bold tracking-wide drop-shadow-lg">
                           
                           
                            </motion.span>
                            :""}

                           { window.innerWidth>656? 
                           <button style={{
                            transition:"all 0.4s ease",pointerEvents:"auto",transform:hover?"scale(1.05)":"scale(1)",
                          boxShadow:hover?"0 0 20px white":" 0 0 0 rgba(2, 2, 2, 0)",
                       height:window.innerWidth>656?"61px":"38px",left:window.innerWidth>656?0:"30px",
                       backgroundColor: "black",
                                  color: "white",
                                  width: "fit-content",
                                  cursor: "pointer",
                                  border: "2px solid white",
                                  borderRadius: "33px",
                                  fontWeight: "500",
                                  position: "relative",
                                  overflow: "hidden",}} 
                           
                            onMouseEnter={()=>setHover(true)}
                            onMouseLeave={()=>setHover(false)}
                            onClick={handle3d}
                             className="btn button2 button-secondary colorful-button open-3d-button">

                            
                                Customize your design
                            </button>
                            :""}

                           
                          </div>
                          
                           {/*mobile view button  */}
                          {window.innerWidth<656 &&
                             <button style={{
                            transition:"all 0.4s ease",pointerEvents:"auto",transform:hover?"scale(1.05)":"scale(1)",
                          boxShadow:hover?"0 0 20px white":" 0 0 0 rgba(2, 2, 2, 0)",
                    zIndex:100,bottom:"4rem",left:"16vw",
                       backgroundColor: "black",
                                  color: "white",
                                  width: "fit-content",
                                  cursor: "pointer",
                                  border: "2px solid white",
                                  borderRadius: "33px",
                                  fontWeight: "500",
                                 position:"absolute",
                                  overflow: "hidden",}} 
                           
                            onMouseEnter={()=>setHover(true)}
                            onMouseLeave={()=>setHover(false)}
                            onClick={handle3d}
                             className="btn button2 button-secondary colorful-button open-3d-button">

                            
                                Customize your design
                            </button>
                            }
    </div>
  );
}

export default Banner;